import { render, staticRenderFns } from "./SearchResultProduct.vue?vue&type=template&id=0671f460&scoped=true&"
import script from "./SearchResultProduct.vue?vue&type=script&lang=js&"
export * from "./SearchResultProduct.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultProduct.vue?vue&type=style&index=0&id=0671f460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671f460",
  null
  
)

export default component.exports